// Module
var code = "<svg aria-hidden=\"true\" :role=\"title ? 'img' : null\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" @click=\"$emit('click', $event.target)\" @keydown=\"$emit('keydown', $event)\" @keyup=\"$emit('keyup', $event)\"> <use ref=\"use\" :xlink:href=\"href\"/> </svg> ";
// Exports
export default code;